<template>
  <div class="ml-6 mr-6" :style="navbarWithName ? 'margin-left: 165px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
      <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
    <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-breadcrumbs :items="page" class="pa-0 ma-0 mt-0 pt-0 "></v-breadcrumbs>
    <v-layout row wrap class="mt-4">
      <v-flex sm12 xs12 md12 lg12>
        <v-card height="auto" class="mb-6 rounded-lg" flat>
          <v-card-title height="50" class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
            <v-icon small class="mr-4" color="grey">mdi-laptop</v-icon> List {{ this.$store.state.title }}
          </v-card-title>
          <div class="pa-6">
          <v-row>
            <v-col cols="12" sm="2">
              <v-autocomplete
                v-model="id_user" 
                :items="rolename" 
                item-text="name_role" 
                item-value="value_role" 
                label="User Name" 
                @change="CekSubribe()"
                dense
                outlined
                clearable
              />
            </v-col>
          </v-row>
          <v-card outlined style="width: 500px;">
            <v-simple-table class="overflow-card pa-0 ma-0">          
              <template>
                  <thead>
                    <tr>
                      <th class="text-left">SELECT</th>
                      <th class="text-left">ROLE NAME</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(item) in usersubs" :key="item.SEQ_ID" >
                        <td>
                          <v-radio-group v-model="role_id">
                            <v-radio name="active" :value="item.SEQ_ID" />
                          </v-radio-group>
                        </td>
                        <td>{{item.ROLE_NAME}}</td>
                      </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          </div>
          <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mx-3 px-4" color="primary" rounded dark :loading="btnload" @click="save">
                save<v-icon class="ml-2">mdi-content-save-outline</v-icon>
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-flex>
      <v-dialog v-model="dialog" persistent max-width="290">                 
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center"> Loading content, please wait</v-card-text>
          <v-card-title class="align-center justify-center">
              <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialog = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
        <Notification  ref="alert"></Notification>
  </div>
</template>

<script>
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
export default {
    components: {
      Notification: Notification
    },
  data:() => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",

      dialog: false,
      usersubs:[],
      role_id:'',
      value2: 'Enabled',
      id_user:'',
      rolename: [
          {
            value_role: '', 
            name_role: ''
          }
      ],
      privstatus: ['Enabled', 'Disabled'],
  }),
  computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
  
  created () {
      this.initialize()
    },
    methods: {
      async initialize () {
        axios.get("user-subcription",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
            let res = decryptionData(response.data.token);
            this.usersubs = res.table_subcription;

            this.role_id = (res.role_id);
            this.id_user = (res.user_is);
            const role = res.table_ui_users;
            let result = '';
            let arr_data = [];
            if(role.length > 0){
              for (let i = 0; i < role.length; i++) {  
                  result = {
                    value_role :role[i].USER_ID,
                    name_role :role[i].USERNAME 
                  };
                  arr_data.push(result);
              }
              this.rolename= arr_data;
            }
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      async CekSubribe() {
        var urer_id = this.id_user;
        this.dialog = true;
        axios({
        method: "put",
        url: "/user-subcription-byid",
        data: {
                user_id: urer_id
              },
              headers:{'auth-token':localStorage.getItem('token_app')},
              dataType: 'json'
        })
        .then((response) => {

          const data = response.data.data;
          const id_role = typeof data.ROLE_ID !== 'undefined' || data.ROLE_ID !== ''  ? data.ROLE_ID : '';
          // this.id_user = (data.SEQ_ID);
          this.role_id = (id_role);
          setTimeout(() => {
            this.dialog = false;
          }, 1000);  
        })
        .catch((e) => {
          this.role_id = '';

          this.dialog = false;
          console.log(e);
        })
      },
      async save () {
        this.dialog = true;
        axios.put("/subcribe-keyword", 
          {
            user_id:this.id_user,
            role_id:this.role_id,
          },
          
          {headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          )
        .then((response) => {
          // console.log(response);
            setTimeout(() => {
              this.dialog = false;
            }, 1000);  
            var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
          })
        .catch((e) => {
              switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            // this.$refs.alert.error_login(403);
                            
                            this.dialog = false;
                            setTimeout(() => {
                              this.dialog = false;
                            }, 3000);
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                  }
          this.errors=e.response.data.msg;
        });
      }
    }
}
</script>

<style scoped> 
/*note css jangan diubah*/
.v-sheet--offset {
  top: -24px;
  position: relative;
}
#app{
  background-color: #F4F7FA;
}
.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner{
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 13px !important;
  max-width: 100px;
}
.row-pointer{
  cursor: grab;
}
svg {
  display: block;
  margin: 0 auto;
}
.chart {
  transition: transform 0.7s ease-in-out;
  text-anchor: middle;
  cursor: pointer;
}
.chart__circle {
  transition: r .3s ease-in-out;
}
.chart__label {
  fill: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.v-select.label{
  color: #fff;
}

</style>
